/**
 * PageHeader action overflow (design/ux/01_foundations.md §3.13, §5.4): at most
 * `max` actions stay inline — the primary ones first — and the rest go into the
 * « Plus… » menu; the inline actions keep the order the page gave.
 */
import { BREAKPOINTS, PAGE_HEADER_INLINE_ACTIONS } from "@/config/ui.config.js";

/**
 * @template {{id: string, variant?: string, hidden?: boolean}} A
 * @param {A[]} actions
 * @param {number} max
 * @returns {{inline: A[], overflow: A[]}}
 */
export function splitActions(actions, max) {
  const list = (actions ?? []).filter((a) => a && !a.hidden);
  if (list.length <= max) return { inline: list, overflow: [] };
  const keep = new Set();
  for (const a of list) if (a.variant === "primary" && keep.size < max) keep.add(a.id);
  for (const a of list) if (keep.size < max) keep.add(a.id);
  return {
    inline: list.filter((a) => keep.has(a.id)),
    overflow: list.filter((a) => !keep.has(a.id)),
  };
}

/** Inline action budget for a viewport width. */
export function inlineActionBudget(viewportWidth) {
  if (viewportWidth == null) return PAGE_HEADER_INLINE_ACTIONS.DESKTOP;
  if (viewportWidth < BREAKPOINTS.TABLET) return PAGE_HEADER_INLINE_ACTIONS.PHONE;
  if (viewportWidth < BREAKPOINTS.DESKTOP_SMALL) return PAGE_HEADER_INLINE_ACTIONS.TABLET;
  return PAGE_HEADER_INLINE_ACTIONS.DESKTOP;
}
